import Layout from '../components/Layout'
import { PageHeader, Section, Card, StatCard } from '../components/UIComponents'

export default function Rewards() {
  return (
    <Layout>
      <div className="space-y-8 max-w-6xl mx-auto">
        <PageHeader
          icon="🏆"
          title="Rewards"
          description="Tus puntos y recompensas acumuladas"
        />

        <Section title="Tu Balance">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            <StatCard
              icon="⭐"
              label="Puntos Totales"
              value="0"
              change="0"
              changeType="up"
            />
            <StatCard
              icon="🎁"
              label="Canjeables Hoy"
              value="0"
              change="0"
              changeType="up"
            />
            <StatCard
              icon="🏅"
              label="Nivel"
              value="1"
              change="0"
              changeType="down"
            />
          </div>
        </Section>

        <Section title="Rewards Disponibles">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {[
              { name: 'Descuento 10%', cost: '500 pts', icon: '💳' },
              { name: 'Bonus $5', cost: '1000 pts', icon: '💰' },
              { name: 'Acceso VIP', cost: '2000 pts', icon: '👑' },
            ].map((reward, i) => (
              <Card key={i}>
                <div className="space-y-3">
                  <div className="flex items-center gap-2">
                    <span className="text-3xl">{reward.icon}</span>
                    <h3 className="text-white font-semibold">{reward.name}</h3>
                  </div>
                  <button className="w-full px-4 py-2 bg-slate-700 hover:bg-slate-600 text-white text-sm font-semibold rounded-lg transition-colors">
                    Canjear - {reward.cost}
                  </button>
                </div>
              </Card>
            ))}
          </div>
        </Section>

        <Section title="Historial">
          <Card>
            <div className="text-center py-8">
              <p className="text-slate-400">Sin historial de rewards</p>
            </div>
          </Card>
        </Section>
      </div>
    </Layout>
  )
}
